import { CanIAuthContext } from '../../base/auth/context';
import { globalSnbDltNodeName } from '../components/AdminApp';

const allowedCashRoles = ['cash_ops_jr_role', 'cash_ops_sr_role'];
const allowedTreasuryRoles = ['treasury_ops_jr_role', 'treasury_ops_sr_role'];

// TODO: Needs to be refactored once the auth context is available via the token from keycloak
export const abilities = {
  'technical-issuer-agent': (context: CanIAuthContext) => context.member?.roles.includes('technical-issuer-agent'),
  'system-operator': (context: CanIAuthContext) => context.member?.roles.includes('system-operator'),
  'scheduler:tick': (context: CanIAuthContext) => context.member?.dltNodeName?.includes('O=SDX'),
  'snb-agent': (context: CanIAuthContext) => context.member?.dltNodeName.toLowerCase() === globalSnbDltNodeName?.toLowerCase(),
  'payment-instruction-internal': (context: CanIAuthContext) =>
    allowedCashRoles.some(role => context.user?.roles.includes(role)) && !allowedTreasuryRoles.some(role => context.user?.roles.includes(role)),
  'asset:create': (context: CanIAuthContext) => true, //context.member.memberRole === 'SDX',
  'onboarding:onboardMember': (context: CanIAuthContext) => {
    const isSdxMember = context.member?.dltNodeName?.includes('O=SDX');
    const isOperatorMember = context.member?.roles.includes('system-operator');
    const isOperatorUser = !!context.user.roles.find(r => r.startsWith('sdx_oper')); // all operators can access (e.g. jr, sr, su)
    return isSdxMember && isOperatorMember && isOperatorUser;
  },
  'asset-types-cryptocurrency': (context: CanIAuthContext) => {
    if (window.location.hostname.match(/\bcrypto\b/) && window.location.hostname.includes('.dx01.')) {
      return true;
    }
    if (process.env.REACT_APP_CRYPTO != null) {
      return process.env.REACT_APP_CRYPTO.toLowerCase() === 'true';
    }
    return context.member.assetTypes.includes('Cryptocurrency') || false;
  },
  'snb-agent-on-behalf': (context: CanIAuthContext) => {
    return !!context.user?.actingMember;
  },
};

export type AdminAbilities = typeof abilities;
